
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { NameSpecifiedEntity } from "../../../../domain/entity";
import { ModelEditableMixin } from "../../mixins";
import { StandardOption } from ".";

@Component({
})
export default class MasterSelectableMixin extends Mixins(ModelEditableMixin) {
  data(): any {
    return {
      values: null,
    };
  }
  values: NameSpecifiedEntity<any>[];

  get isLoaded(): boolean {
    return !!this.values;
  }

  get options(): StandardOption<any>[] {
    return Enumerable.from(this.values)
      .select(v => new StandardOption<any>(v.name, v))
      .toArray();
  }

  areIdsEqual(source: NameSpecifiedEntity<any>, destination: NameSpecifiedEntity<any>): boolean {
    return NameSpecifiedEntity.areIdsEqual<any>(source, destination);
  }
}
